var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ra-avatar",style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px"),
    backgroundColor: _vm.fallbackBackground,
    borderRadius: _vm.borderRadius
  })},[_c('img',{class:{ 'user-icon': !_vm.src },style:({ height: _vm.src ? '100%' : ((_vm.size / 2.5) + "px") }),attrs:{"src":_vm.src || _vm.fallbackIcon,"alt":"User"}})])}
var staticRenderFns = []

export { render, staticRenderFns }